<template>
  <div>
    <video v-if="!permissionDenied" ref="videoElement" autoplay></video>
    <button v-if="permissionDenied" @click="startCamera">
      Allow Camera Access
    </button>
    <button v-if="!permissionDenied" @click="capturePhoto">
      Capture Photo
    </button>
    <canvas ref="canvasElement" style="display: none"></canvas>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

const videoElement = ref(null);
const canvasElement = ref(null);
const permissionDenied = ref(false);

const startCamera = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    if (videoElement.value) {
      videoElement.value.srcObject = stream;
      permissionDenied.value = false;
    }
  } catch (error) {
    console.error("Error accessing the camera:", error);
    if (
      error.name === "NotAllowedError" ||
      error.name === "PermissionDeniedError"
    ) {
      permissionDenied.value = true;
    }
  }
};

const stopCamera = () => {
  const stream = videoElement.value?.srcObject;
  if (stream) {
    const tracks = stream.getTracks();
    tracks.forEach((track) => track.stop());
  }
};

const capturePhoto = () => {
  if (videoElement.value && canvasElement.value) {
    const context = canvasElement.value.getContext("2d");
    canvasElement.value.width = videoElement.value.videoWidth;
    canvasElement.value.height = videoElement.value.videoHeight;
    context.drawImage(
      videoElement.value,
      0,
      0,
      canvasElement.value.width,
      canvasElement.value.height
    );
    canvasElement.value.toBlob((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "photo.png";
      link.click();
    });
  }
};

onMounted(() => {
  startCamera();
});

onBeforeUnmount(() => {
  stopCamera();
});
</script>

<style scoped>
video {
  width: 100%;
  max-width: 640px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
button {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  background-color: #007bff;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}
button:hover {
  background-color: #0056b3;
}
</style>
